// eslint-disable-next-line import/prefer-default-export
export const required = (message = 'Required') => value => (value ? undefined : message);



// WEBPACK FOOTER //
// ./src/lib/validation.js